/**
 * Pick a cover uri for a game, given the API's ratio-keyed covers (#87).
 *
 * 1x1 first because both the splash and the in-frame thumb are square-ish boxes; 16x9 is the
 * fallback since every imported game has one. Returns null when the game has no artwork at
 * all, so callers can show their own placeholder instead of crashing on an empty url.
 */
export function pickCover(covers) {
  if (!covers) return null;
  return covers['1x1'] || covers['16x9'] || covers['2x3'] || null;
}
